import { render } from "./OrderPoints.vue?vue&type=template&id=27327dd7&scoped=true"
import script from "./OrderPoints.vue?vue&type=script&lang=js"
export * from "./OrderPoints.vue?vue&type=script&lang=js"

import "./OrderPoints.vue?vue&type=style&index=0&id=27327dd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27327dd7"]])

export default __exports__